import React from 'react';

import { termsAndConditionsOfSale } from '../../content/legal';
import LegalPage from '../LegalPage/LegalPage';

// The Terms & Conditions of Sale — the terms of the contract between a shopper
// and the brand they buy from — rendered from the copy in src/content/legal.
const TermsAndConditionsOfSalePage = () => (
  <LegalPage doc={termsAndConditionsOfSale} currentPage="TermsAndConditionsOfSalePage" />
);

export default TermsAndConditionsOfSalePage;
